import { Injectable, NgModule, inject } from '@angular/core';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard,
  CoreUtils,
  CoreUtilsService
} from '@bepatient/core';
import {
  MyFormActionLoadForm,
  selectorMyFormForm
} from '@bepatient/my-form-store';
import { Store } from '@ngrx/store';

@Injectable()
export class MyFormGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(store, selectorMyFormForm, new MyFormActionLoadForm());
  }
}

const myFormModule: CorePageModule = {
  ID: CorePageModuleIDs.MY_FORM,
  leftMenuAvailableForDepthModules: true,
  routes: CoreUtils.generateDepthModuleRoutes(
    'my-form',
    () =>
      import('./pages/my-form/my-form.module').then(
        module => module.MyFormPageModule
      ),
    MyFormGuard
  )
};

@NgModule({
  providers: [
    MyFormGuard,
    { provide: CORE_PAGE_MODULE, useValue: myFormModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './my-form/i18n/', multi: true }
  ]
})
export class MyFormModule {
  constructor() {
    const coreUtilsService = inject(CoreUtilsService);

    coreUtilsService.addDepthModuleRoutes(myFormModule);
  }
}
